import React, { PureComponent } from 'react'

import PropTypes from 'prop-types'

import { CollectionId } from 'routes/Menu/domains/collections'

import { DetailOverlay } from '../../components/Detail'
import { RecipeList } from '../RecipeList'
import { RecipeGridDescription } from './RecipeGridDescription'

import css from '../../Menu.css'

class RecipeGrid extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      shouldShowOverlay: false,
    }
  }

  componentDidMount() {
    this.setState({ shouldShowOverlay: true })
  }

  render() {
    const { shouldShowOverlay } = this.state
    const { menuCurrentCollectionId, menuPreferences } = this.props
    const isRecommendations = menuCurrentCollectionId === CollectionId.Recommendations

    return (
      <div className={css.menuContainer} data-testid="menuRecipesList">
        {isRecommendations && (
          <RecipeGridDescription
            title="Based on what you've had before"
            text="We think you'll love these recipes"
          />
        )}
        <RecipeList menuPreferences={menuPreferences} />
        <DetailOverlay showOverlay={shouldShowOverlay} />
      </div>
    )
  }
}

RecipeGrid.propTypes = {
  query: PropTypes.shape({
    collection: PropTypes.string,
  }),
  menuCurrentCollectionId: PropTypes.string,
  menuPreferences: PropTypes.shape({
    display: PropTypes.shape({
      list: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          type: PropTypes.string.isRequired,
          selected: PropTypes.bool.isRequired,
        }),
      ),
    }),
    dietary: PropTypes.shape({
      list: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          type: PropTypes.string.isRequired,
          selected: PropTypes.bool.isRequired,
        }),
      ),
    }),
    equipment: PropTypes.shape({
      list: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          id: PropTypes.string.isRequired,
          selected: PropTypes.bool.isRequired,
        }),
      ),
    }),
  }),
}

RecipeGrid.defaultProps = {
  query: {},
  menuCurrentCollectionId: '',
  menuPreferences: null,
}

export { RecipeGrid }
